<div class="app-container">
  <thehubz-header class="app-header-container" (loginRequest)="loginRequest()" redirectUri="/jackpot-assets"></thehubz-header>
  <main class="app-main-container application-feature-modules">
    <div class="app-wrapper h-full">
      <router-outlet></router-outlet>
    </div>
  </main>
  <div class="app-footer-container">
    <div class="footer-contant">
      <sp-footer></sp-footer>
    </div>
  </div>
</div>
